/* global lightGallery:false */
/* global lgThumbnail:false */

var lightgalleries = document.querySelectorAll('.lightgallery');

for (var i = 0 ; i < lightgalleries.length; i++) {
	lightGallery(lightgalleries[i], {
		plugins: [lgThumbnail],
		selector: '.lightgallery-item',
		speed: 500,
		download: false,
		licenseKey: '0000-0000-000-0000',
	});
}
